import React from "react";
import Agent from "./agent.jsx";
export const createUnavailability = async (shopId, unavailability) => {
  try {
    const token = localStorage.getItem("authToken");
    const params = {
      ShopId: shopId,
      BarberId: unavailability.BarberId,
      FromDate: unavailability.FromDate, // e.g. "Monday" or number (0-6)
      ToDate: unavailability.ToDate, // e.g. "Monday" or number (0-6)
      StartTime: unavailability.StartTime, // "09:00:00"
      EndTime: unavailability.EndTime, // "17:00:00"
      Reason: unavailability.Reason,
    };
    const { requests } = Agent();
    return await requests.post(`/BarberUnavailability/`, params, token, shopId);
  } catch (error) {
    console.error(
      "Error updating barber unavailability:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getUnavailabilityByBarber = async (
  shopId,
  barberId,
  selectedFromDate,
  selectedToDate
) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const token = localStorage.getItem("authToken");
  const params = {
    BarberId: barberId, //ensure it's formatted correctly
    ShopId: shopId,
    FromDate: selectedFromDate,
    ToDate: selectedToDate,
  };
  const { requests } = Agent();
  return await requests.getAtt(`/BarberUnavailability/`, params, token, shopId);
};

export const updateUnavailability = async (shopId, unavailability) => {
  try {
    const token = localStorage.getItem("authToken");
    const params = {
      Id: unavailability.id,
      ShopId: shopId,
      BarberId: unavailability.barberId,
      Date: unavailability.date,
      StartTime: unavailability.startTime, // "09:00:00"
      EndTime: unavailability.endTime, // "17:00:00"
      Reason: unavailability.reason,
    };
    const { requests } = Agent();
    return await requests.put(`/BarberUnAvailability/`, params, token, shopId);
  } catch (error) {
    console.error(
      "Error updating barber unavailability:",
      error.response?.data || error.message
    );
    throw error;
  }
};
export const deleteUnavailability = async (
  shopId,
  barberId,
  availabilityId
) => {
  try {
    const token = localStorage.getItem("authToken");

    const { requests } = Agent();
    return await requests.del(
      `/BarberUnAvailability?id=${availabilityId}&barberId=${barberId}&shopId=${shopId}`,
      token,
      shopId
    );
  } catch (error) {
    console.error(
      "Error updating barber unavailability:",
      error.response?.data || error.message
    );
    throw error;
  }
};
